import React from 'react';
import { CircularProgress, Box, Typography, Fade } from '@mui/material';

const LoadingScreen = ({ message = "Loading your session..." }) => {
  return (
    <Fade in={true} timeout={300}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: '#f5f5f5',
          gap: 3,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999
        }}
      >
        <CircularProgress 
          size={80} 
          thickness={4} 
          sx={{ 
            color: '#1976d2',
            animation: 'spin 1s linear infinite'
          }} 
        />
        <Typography 
          variant="h5" 
          color="text.primary"
          sx={{ 
            fontWeight: 500,
            textAlign: 'center'
          }}
        >
          {message}
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ 
            textAlign: 'center',
            maxWidth: '400px'
          }}
        >
          Please wait while we verify your authentication...
        </Typography>
      </Box>
    </Fade>
  );
};

export default LoadingScreen;